// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__nmh0r","footerContent":"Footer_footerContent__X6dQ2","footerLinks":"Footer_footerLinks__TJJB2","footerBottom":"Footer_footerBottom__H6F8Q"};